import { gql } from "@apollo/client";

const SAVE_ACCOUNT_V2 = gql`
  mutation saveAccountV2(
    $urlName: String
    $name: String
    $newUrlName: String
    $setDefaultDeadline: String
    $removeDefaultDeadline: Boolean
    $setSummaryTime: String
    $removeSummaryTime: Boolean
    $setSummaryRecipients: [String!]
    $clearSummaryRecipients: Boolean
    $showDownloadSummary: Boolean
    $contractedRowCount: BigInt
  ) {
    saveAccountV2(
      urlName: $urlName
      account: {
        name: $name
        urlName: $newUrlName
        setDefaultDeadline: $setDefaultDeadline
        removeDefaultDeadline: $removeDefaultDeadline
        setSummaryTime: $setSummaryTime
        removeSummaryTime: $removeSummaryTime
        setSummaryRecipients: $setSummaryRecipients
        clearSummaryRecipients: $clearSummaryRecipients
        showDownloadSummary: $showDownloadSummary
        contractedRowCount: $contractedRowCount
      }
    ) {
      ... on ResultOk {
        ok
      }
      ... on SaveAccountErrors {
        errors {
          ... on ConflictingNameError {
            message
          }
          ... on ConflictingUrlNameError {
            message
          }
        }
      }
    }
  }
`;

const DEACTIVATE_ACCOUNT_V2 = gql`
  mutation deactivateAccountV2($urlName: String!) {
    deactivateAccountV2(urlName: $urlName) {
      ok
    }
  }
`;

const RESET_AUTH0_PASSWORD = gql`
  mutation resetAuth0Password($email: String!) {
    resetAuth0Password(email: $email) {
      ok
    }
  }
`;

const BLOCK_USER = gql`
  mutation setAuth0UserBlock($id: String!, $blocked: Boolean!) {
    setAuth0UserBlock(id: $id, blocked: $blocked) {
      ok
    }
  }
`;

export { BLOCK_USER, DEACTIVATE_ACCOUNT_V2, RESET_AUTH0_PASSWORD, SAVE_ACCOUNT_V2 };
